module.exports = __webpack_public_path__ + "img/lazer_promo.786e7b09.png";